// src/views/Legal/PrivacyPolicy.js
import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto px-6 py-10 text-gray-800">
      <h1 className="text-3xl font-bold text-orange-600 mb-6">
        Política de Privacidad
      </h1>

      <p className="mb-4">
        En nuestra empresa respetamos tu privacidad. Esta Política explica cómo
        recopilamos, usamos y protegemos tus datos personales cuando interactúas
        con nuestros servicios.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">1. Información que recopilamos</h2>
      <p className="mb-4">
        Podemos recopilar tu nombre, correo electrónico, número de teléfono,
        información de negocio y datos de uso del sitio cuando te registras o
        utilizas nuestras herramientas digitales.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">2. Uso de la información</h2>
      <p className="mb-4">
        La información se utiliza para mejorar nuestros servicios, contactarte
        sobre productos relevantes, y cumplir con requisitos legales o
        contractuales.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">3. Protección de datos</h2>
      <p className="mb-4">
        Implementamos medidas de seguridad técnicas y administrativas para
        proteger tus datos contra accesos no autorizados o divulgación.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">4. Terceros</h2>
      <p className="mb-4">
        Podemos compartir información mínima con plataformas de publicidad o
        CRM, como TikTok, Facebook y Google Ads, únicamente con fines de gestión
        de campañas y seguimiento de conversiones.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">5. Tus derechos</h2>
      <p className="mb-4">
        Puedes solicitar la eliminación o modificación de tus datos personales
        enviando un correo a: <strong>soporte@tudominio.com</strong>.
      </p>

      <p className="text-sm text-gray-500 mt-8">
        Última actualización: {new Date().toLocaleDateString("es-PR")}
      </p>
    </div>
  );
};

export default PrivacyPolicy;
